module.exports = __webpack_public_path__ + "static/img/essential2-new.6cd9e5b0.png";